import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const faqs = [
    {
      question: "Wie ist die SKS-Prüfung aufgebaut?",
      answer: "Die SKS-Prüfung gliedert sich in zwei Teile: einen Theorieteil mit offenen Fragen und einen Abschnitt für die Kartenaufgaben. Für beide Teile stehen jeweils 90 Minuten zur Verfügung."
    },
    {
      question: "Ist die mein-sks.net App ausreichend, um mich auf die komplette Prüfung vorzubereiten?",
      answer: "Die App fokussiert sich auf die Beantwortung offener Theoriefragen. Für die Vorbereitung auf die Kartenaufgaben ist ein ergänzender Lernmodus erforderlich. In unserem Wiki findest Du detaillierte Hinweise, wie Du Dich optimal auf diese Aufgaben vorbereiten kannst."
    },
    {
      question: "Wie ist der Lernmodus der mein-sks App aufgebaut?",
      answer: "Wir setzen auf digitale Karteikarten, um Dir das Lernen offener Fragestellungen zu erleichtern. Mit diesen Karten erhältst Du nicht nur die Fragen und Antworten, sondern auch eine ausführliche Erklärung zu jeder Antwort."
    },
    {
      question: "Beinhaltet die App die originalen Prüfungsfragen und Prüfungsbögen?",
      answer: "Ja, die Applikation enthält alle originalen Prüfungsfragen und Prüfungsbögen."
    },
    {
      question: "Wie funktioniert die Fortschrittsmessung?",
      answer: "Während des Lernens werden Deine richtigen und falschen Antworten erfasst. Abhängig von Deinem individuellen Lernfortschritt werden die Fragen in gehirngerechten Intervallen im Wiederholungsteil der App erneut präsentiert."
    },
    {
      question: "Kann ich die App kostenlos testen?",
      answer: "Ja, nach der Registrierung kannst Du die App mit 150 Fragen kostenlos testen und dabei den vollen Funktionsumfang nutzen. Danach hast Du die Möglichkeit, ein Jahresabo zu erwerben."
    },
    {
      question: "Gibt es eine Geld-zurück-Garantie?",
      answer: "Da Du die Applikation vor dem Kauf mit 150 Fragen ausgiebig testen kannst, bieten wir keine explizite Geld-zurück-Garantie an. In Ausnahmefällen setzen wir uns jedoch mit Dir in Verbindung, um gemeinsam eine zufriedenstellende Lösung zu finden."
    }
  ];

  return (
    <section className="py-16 bg-base-200">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center max-w-3xl mx-auto mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-4">
            <div className="bg-primary/10 p-3 rounded-full">
              <HelpCircle className="w-8 h-8 text-primary" />
            </div>
          </div>
          <h2 className="text-3xl font-bold mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-lg text-base-content/70">
            Hier findest Du Antworten auf die wichtigsten Fragen zur SKS-Prüfung und unserer App
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="collapse collapse-arrow bg-base-100 shadow-sm hover:shadow-md transition-all">
                  <input type="checkbox" /> 
                  <div className="collapse-title text-lg font-medium pr-12">
                    {faq.question}
                  </div>
                  <div className="collapse-content">
                    <p className="text-base-content/80 pt-2">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection; 
